import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface CurrentLocation {
  id: number;
  name: string;
  phone: string;
  email: string;
  address: string;
  is_active: string;
  created_at: string;
  updated_at: string;
  shipping_cost: string;
  delivery_cost: string;
}

interface CurrentLocationState {
  currentLocation: CurrentLocation | null;
  isLoading: boolean;
}

const initialState: CurrentLocationState = {
  currentLocation: null,
  isLoading: false,
};

const currentLocationSlice = createSlice({
  name: 'currentLocation',
  initialState,
  reducers: {
    // Set current location
    setCurrentLocation: (
      state,
      action: PayloadAction<CurrentLocation | null>
    ) => {
      state.currentLocation = action.payload;
    },

    // Update current location
    updateCurrentLocation: (
      state,
      action: PayloadAction<Partial<CurrentLocation>>
    ) => {
      if (state.currentLocation) {
        state.currentLocation = { ...state.currentLocation, ...action.payload };
      }
    },

    // Clear current location
    clearCurrentLocation: (state) => {
      state.currentLocation = null;
    },

    // Set loading state
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
  },
});

export const {
  setCurrentLocation,
  updateCurrentLocation,
  clearCurrentLocation,
  setLoading,
} = currentLocationSlice.actions;

export default currentLocationSlice.reducer;
